import { useCategories } from '@ilteducation/content-ref-data';
import { computed } from 'vue';
import type { Category } from '@ilteducation/content-ref-data-types';

const filterMap = {
  grades: ['Årskurs F-3', 'Årskurs 1-3', 'Årskurs 4-6', 'Årskurs 7-9', 'Gymnasiet'],
}; //TODO cleaner solution

export const useBookSearch = () => {
  const { categories } = useCategories();

  const grades = computed<Category[]>(() =>
    categories.value
      .filter((c) => c.kind === 'grade' && filterMap.grades.includes(c.category))
      .toSorted((a, b) => {
        const aIndex = filterMap.grades.indexOf(a.category);
        const bIndex = filterMap.grades.indexOf(b.category);
        return aIndex - bIndex;
      }),
  );

  return {
    grades,
  };
};
